import Box from "@mui/material/Box";
import React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import "@styles/SingleHotelViewcss/Dashboard.css";
import "@styles/UserManagement/UserManagement.css";
import AdminStaffTable from "./Tabs/AdminStaffTable";
import AddAdminModal from "./Tabs/AddAdminModal";
import FoodcourtTable from "./Tabs/FoodCourt";

const tabStyle = {
  fontStyle: "normal",
  letterSpacing: "0px",
  textTransform: "capitalize",
  fontSize: "14px",
  marginLeft: "25px",
  padding: "0px",
  marginRight: "10px",
  fontWeight: "600",
};

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 0 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
const UsersPage: React.FC = () => {
  const [value, setValue] = React.useState(0);
  const [openModal, setOpenModal] = React.useState(false);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  return (
    <div className="usercontainer">
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
              sx={{ display: "flex", gap: "10px" }}
            >
              <Tab
                sx={tabStyle}
                label="Food Court Owners/Staff"
                {...a11yProps(0)}
              />
              <Tab
                sx={tabStyle}
                label="Sermyble Admin Staff"
                {...a11yProps(1)}
              />
            </Tabs>
          </div>
          <div style={{ marginRight: "20px", paddingBlock: "12px" }}>
            <div style={{ display: "flex", gap: "15px", alignItems: "center" }}>
              {value === 1 && (
                <div>
                  <button onClick={handleOpenModal} className="AddAdminButton">
                    Add Admin Staff
                  </button>
                </div>
              )}

              <div className="search-box2">
                <button>
                  <i className="bx bx-search" />
                </button>
                <input type="text" placeholder="Search..." />
              </div>

              <div>
                <div className="dropdown">
                  <button className="dropdown2-btn">
                    <i
                      className="bx bx-filter"
                      style={{ marginRight: "4px", height: 12 }}
                    />
                    Filters
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* className="searchdiv" */}
      </Box>
      <AddAdminModal open={openModal} handleClose={handleCloseModal} />

      <CustomTabPanel value={value} index={0}>
        <div className="">
          <FoodcourtTable />
        </div>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <div className="">
          <AdminStaffTable />
        </div>
      </CustomTabPanel>
    </div>
  );
};

export default UsersPage;
